import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import PropTypes from 'prop-types';


const ConceptosErroneos = ({ promptData, setPromptData}) => {
    
    const { proyecto, setProyecto } = useProyecto();

    const handleConceptosErroneos = (event) => {
        const { value } = event.target;
        setProyecto({...proyecto,  conceptos_errados: value
        });
        setPromptData((prevData) => ({
            ...prevData,
            conceptos_errados: value 
          }));
      };
    
    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >¿Qué conceptos/temas suelen ser más difíciles de comprender para los estudiantes? </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}> Indica aquí las concepciones erróneas que hayas identificado en tus estudiantes y para las cuales te gustaría recibir sugerencias de trabajo en el aula</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Escribe concepciones erróneas ya identificadas aquí. ej: Los elementos no vivos no forman parte de los ecosistemas'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.conceptos_errados}
                onChange={handleConceptosErroneos}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

ConceptosErroneos.propTypes = {
  promptData: PropTypes.func.isRequired,
  setPromptData: PropTypes.func.isRequired,
};

export default ConceptosErroneos;




